module.exports = __webpack_public_path__ + "static/adam-bdd6518e7515665d750bdabaaeefdd74.png";